import { PoStatusBadge } from './PoStatusBadge';
import type { PoStatusKind } from './poStatus';

interface PoStatusCellProps {
    kind: PoStatusKind;
    status: string;
    /** Always carries its own label - the pill above it cannot say which date it is. */
    moment: string | null;
}

// w-full is what makes `truncate` bite: without it the line sizes to its text
// and overflows the fixed column into its neighbour.
export function PoStatusCell({ kind, status, moment }: PoStatusCellProps) {
    return (
        <span className="flex flex-col gap-0.5 items-start">
            <PoStatusBadge kind={kind} value={status} />
            {moment && <span className="w-full text-[11px] text-gray-400 truncate">{moment}</span>}
        </span>
    );
}
